module.exports = __webpack_public_path__ + "img/st.29664c6f.png";